'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var Search$2 = require('../../node_modules/@material-ui/icons/Search.js');
var TextField = require('../../core/TextField.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var grey = require('../../node_modules/@material-ui/core/esm/colors/grey.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    search: {
      paddingLeft: 10,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: grey[100],
      '&:hover': {
        backgroundColor: grey[200]
      },
      marginLeft: 0,
      display: 'flex',
      alignItems: 'center'
    },
    searchIcon: {
      height: '100%',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 5
    },
    inputRoot: {
      color: theme.palette.secondary.main,
      width: '100%'
    },
    inputRootLarge: {
      color: theme.palette.secondary.main,
      width: '100%',
      fontSize: 16,
      padding: "12px 12px 12px 0"
    }
  };
};

var Search = function Search(_ref) {
  var classes = _ref.classes,
      size = _ref.size,
      placeholder = _ref.placeholder,
      showError = _ref.showError,
      restProps = objectWithoutProperties(_ref, ["classes", "size", "placeholder", "showError"]);

  var inputStyle = showError ? {
    backgroundColor: '#fce8e6'
  } : {};
  return React__default["default"].createElement("div", {
    className: classes.search,
    style: inputStyle
  }, React__default["default"].createElement("div", {
    className: classes.searchIcon
  }, React__default["default"].createElement(Search$2, null)), React__default["default"].createElement(TextField, _extends["default"]({
    variant: "standard",
    classes: {
      root: size === "large" ? classes.inputRootLarge : classes.inputRoot
    },
    InputProps: {
      disableUnderline: true
    }
  }, restProps, {
    placeholder: placeholder
  })));
};

Search.defaultProps = {
  placeholder: "search",
  showError: false
};
var Search$1 = withStyles(styles)(Search);

module.exports = Search$1;
